import { useMutation, useQueryClient } from '@tanstack/react-query';

import { customAxios } from 'lib/axios';

const revokeSession = async (sessionId: string): Promise<void> => {
  await customAxios.delete(`/sessions/${sessionId}`);
};

export const useRevokeSession = () => {
  const queryClient = useQueryClient();

  return useMutation<void, Error, string>({
    mutationFn: revokeSession,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['sessions'] }).catch(() => {});
    },
  });
};
